import { createSelector } from '@reduxjs/toolkit';

import {
  PAYMENT_FORM_FEATURE_KEY,
  PaymentFormState,
} from './paymentForm.slice';

export const getPaymentFormState = (rootState: any): PaymentFormState =>
  rootState[PAYMENT_FORM_FEATURE_KEY];

export const selectPaymentInputs = createSelector(
  getPaymentFormState,
  (s) => s.paymentInputs,
);

export const selectInputErrorMap = createSelector(
  getPaymentFormState,
  (s) => s.inputErrorMap,
);

export const selectDropdownOptions = createSelector(
  getPaymentFormState,
  (s) => s.options,
);

export const selectFormReady = createSelector(
  getPaymentFormState,
  (s) => s.isFormReady,
);
